(function () {
  'use strict';

  var root = document.querySelector('[data-gw-compare-root]');
  var dataNode = document.getElementById('GWCompareData');
  if (!root || !dataNode) return;

  var models;
  try {
    models = JSON.parse(dataNode.textContent);
  } catch (error) {
    console.error('Unable to load mouse comparison data.', error);
    return;
  }

  var catalog = root.querySelector('[data-model-catalog]');
  var countNode = root.querySelector('[data-selected-count]');
  var clearButton = root.querySelector('[data-clear-selection]');
  var searchInput = root.querySelector('[data-model-search]');
  var canvas = root.querySelector('[data-comparison-canvas]');
  var shapes = root.querySelector('[data-comparison-shapes]');
  var legend = root.querySelector('[data-comparison-legend]');
  var emptyState = root.querySelector('[data-empty-state]');
  var tableWrap = root.querySelector('[data-comparison-table]');
  var filterButtons = root.querySelectorAll('[data-size-filter]');
  var viewButtons = root.querySelectorAll('[data-view]');
  var axisX = root.querySelector('[data-axis-x]');
  var axisY = root.querySelector('[data-axis-y]');
  var rulerLine = root.querySelector('[data-ruler-line]');
  var heightPanel = root.querySelector('[data-height-panel]');
  var heightBars = root.querySelector('[data-height-bars]');
  var selected = new Set();
  var sizeFilter = 'all';
  var searchTerm = '';
  var currentView = 'top';

  var query = new URLSearchParams(window.location.search);
  var queryModels = (query.get('models') || '').split(',').filter(Boolean);
  queryModels.forEach(function (id) {
    if (models.some(function (model) { return model.id === id; }) && selected.size < 4) {
      selected.add(id);
    }
  });
  if (selected.size < 2) {
    ['warg', 'hsk-pro', 'htm-plus'].forEach(function (id) { selected.add(id); });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getSelectedModels() {
    return models.filter(function (model) { return selected.has(model.id); });
  }

  function sizeLabel(size) {
    return size === 'small' ? '小型' : size === 'large' ? '大型' : '中型';
  }

  function renderCatalog() {
    var maxed = selected.size >= 4;
    var visible = models.filter(function (model) {
      var matchesSize = sizeFilter === 'all' || model.size === sizeFilter;
      var haystack = (model.name + ' ' + model.fullName + ' ' + model.shape + ' ' + model.grips.join(' ')).toLowerCase();
      return matchesSize && haystack.indexOf(searchTerm) !== -1;
    });

    catalog.innerHTML = visible.map(function (model) {
      var isSelected = selected.has(model.id);
      var disabled = maxed && !isSelected;
      return (
        '<button type="button" class="gw-compare-model' + (isSelected ? ' is-selected' : '') + '"' +
          ' data-model-id="' + escapeHtml(model.id) + '"' +
          ' aria-pressed="' + isSelected + '"' +
          (disabled ? ' disabled' : '') + '>' +
          '<span class="gw-compare-model__check" aria-hidden="true">' + (isSelected ? '✓' : '+') + '</span>' +
          '<span class="gw-compare-model__media">' +
            '<img src="' + escapeHtml(model.image) + '" alt="" loading="lazy">' +
          '</span>' +
          '<span class="gw-compare-model__body">' +
            '<strong>' + escapeHtml(model.name) + '</strong>' +
            '<small>' + escapeHtml(sizeLabel(model.size)) + ' · ' + escapeHtml(model.shape) + '</small>' +
            '<span>' + escapeHtml(model.length) + ' × ' + escapeHtml(model.width) + ' × ' + escapeHtml(model.height) + ' mm</span>' +
          '</span>' +
        '</button>'
      );
    }).join('');

    if (!visible.length) {
      catalog.innerHTML = '<p class="gw-compare-no-results">没有找到匹配型号，请尝试其他关键词或尺寸。</p>';
    }
    countNode.textContent = selected.size;
  }

  function updateQuery() {
    var url = new URL(window.location.href);
    url.searchParams.set('models', Array.from(selected).join(','));
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  function renderHeightBars(chosen) {
    var maxHeight = Math.max.apply(null, chosen.map(function (model) { return model.height; }));
    heightBars.innerHTML = chosen.map(function (model) {
      var percentage = (model.height / maxHeight * 100).toFixed(1);
      return (
        '<div class="gw-compare-height-item">' +
          '<div class="gw-compare-height-item__track" aria-hidden="true">' +
            '<i style="height:' + percentage + '%;background:' + escapeHtml(model.color) + '"></i>' +
          '</div>' +
          '<div><strong>' + escapeHtml(model.name) + '</strong>' +
          '<span><b>' + model.height + '</b> mm</span></div>' +
        '</div>'
      );
    }).join('');
  }

  function renderShapes() {
    var chosen = getSelectedModels();
    var enough = chosen.length >= 2;
    emptyState.hidden = enough;
    canvas.hidden = !enough;
    legend.hidden = !enough;
    heightPanel.hidden = !enough;

    if (!enough) {
      shapes.innerHTML = '';
      legend.innerHTML = '';
      heightBars.innerHTML = '';
      return;
    }

    var canvasRect = canvas.getBoundingClientRect();
    var usableWidth = Math.max(250, canvasRect.width - 120);
    var usableHeight = Math.max(280, canvasRect.height - 100);
    var maxLength = Math.max.apply(null, chosen.map(function (model) { return model.length; }));
    var maxWidth = Math.max.apply(null, chosen.map(function (model) {
      return currentView === 'top' ? model.width : model.height;
    }));
    var scale = currentView === 'top'
      ? Math.min(usableHeight / maxLength, usableWidth / maxWidth)
      : Math.min(usableWidth / maxLength, usableHeight / maxWidth);

    axisX.textContent = currentView === 'top' ? '宽度 / WIDTH' : '长度 / LENGTH';
    axisY.textContent = currentView === 'top' ? '长度 / LENGTH' : '高度 / HEIGHT';
    canvas.setAttribute(
      'aria-label',
      currentView === 'top' ? '鼠标长度与宽度轮廓对比图' : '鼠标长度与高度侧视轮廓对比图'
    );
    shapes.setAttribute('data-view', currentView);
    rulerLine.style.width = Math.max(22, 10 * scale).toFixed(1) + 'px';

    shapes.innerHTML = chosen.map(function (model, index) {
      var width = currentView === 'top' ? model.width * scale : model.length * scale;
      var height = currentView === 'top' ? model.length * scale : model.height * scale;
      var classes = 'gw-compare-shape gw-compare-shape--' + currentView;
      if (model.shape.indexOf('非对称') !== -1) classes += ' gw-compare-shape--asym';
      return (
        '<div class="' + classes + '" style="' +
          '--shape-color:' + escapeHtml(model.color) + ';' +
          '--shape-index:' + index + ';' +
          'width:' + width.toFixed(1) + 'px;' +
          'height:' + height.toFixed(1) + 'px;"' +
          ' data-shape-id="' + escapeHtml(model.id) + '">' +
          '<span>' + escapeHtml(model.name) + '</span>' +
          '<i aria-hidden="true"></i>' +
        '</div>'
      );
    }).join('');

    legend.innerHTML = chosen.map(function (model) {
      return (
        '<div><i style="background:' + escapeHtml(model.color) + '"></i>' +
        '<strong>' + escapeHtml(model.name) + '</strong>' +
        '<span>' + model.length + ' × ' + model.width + ' × ' + model.height + ' mm</span></div>'
      );
    }).join('');
    renderHeightBars(chosen);
  }

  function renderTable() {
    var chosen = getSelectedModels();
    if (!chosen.length) {
      tableWrap.innerHTML = '<p class="gw-compare-no-results">选择型号后显示详细参数。</p>';
      return;
    }

    var rows = [
      ['尺寸', function (m) { return m.length + ' × ' + m.width + ' × ' + m.height + ' mm'; }],
      ['重量', function (m) { return '约 ' + m.weight + 'g'; }],
      ['尺寸级别', function (m) { return sizeLabel(m.size); }],
      ['轮廓', function (m) { return m.shape; }],
      ['推荐握法', function (m) { return m.grips.join(' / '); }],
      ['传感器', function (m) { return m.sensor; }],
      ['最高回报率', function (m) { return m.polling; }]
    ];

    var header = '<thead><tr><th scope="col">对比项目</th>' + chosen.map(function (model) {
      return '<th scope="col"><i style="background:' + escapeHtml(model.color) + '"></i>' +
        '<span>' + escapeHtml(model.name) + '</span></th>';
    }).join('') + '</tr></thead>';

    var body = '<tbody>' + rows.map(function (row) {
      return '<tr><th scope="row">' + row[0] + '</th>' + chosen.map(function (model) {
        return '<td>' + escapeHtml(row[1](model)) + '</td>';
      }).join('') + '</tr>';
    }).join('') +
      '<tr class="gw-compare-table__links"><th scope="row">产品页面</th>' +
      chosen.map(function (model) {
        return '<td><a href="' + escapeHtml(model.url) + '">查看 ' + escapeHtml(model.name) + ' →</a></td>';
      }).join('') + '</tr></tbody>';

    tableWrap.innerHTML = '<table class="gw-compare-table">' + header + body + '</table>';
  }

  function renderComparison() {
    renderCatalog();
    renderShapes();
    renderTable();
    updateQuery();
  }

  catalog.addEventListener('click', function (event) {
    var button = event.target.closest('[data-model-id]');
    if (!button) return;
    var id = button.getAttribute('data-model-id');
    if (selected.has(id)) {
      selected.delete(id);
    } else if (selected.size < 4) {
      selected.add(id);
    }
    renderComparison();
  });

  clearButton.addEventListener('click', function () {
    selected.clear();
    renderComparison();
  });

  searchInput.addEventListener('input', function () {
    searchTerm = searchInput.value.trim().toLowerCase();
    renderCatalog();
  });

  filterButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      sizeFilter = button.getAttribute('data-size-filter');
      filterButtons.forEach(function (item) {
        item.classList.toggle('is-active', item === button);
      });
      renderCatalog();
    });
  });

  viewButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      currentView = button.getAttribute('data-view');
      viewButtons.forEach(function (item) {
        item.classList.toggle('is-active', item === button);
      });
      renderShapes();
    });
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(renderShapes, 120);
  });

  renderComparison();
})();
